import React from "react";
import SidebarMenuItems from "./SidebarMenuItems";

// Dikey accordion sidebar gövdesi. Cuba'nın yatay-menü (horizontal-wrapper)
// scroll makinesi (left-arrow/right-arrow + margin/hideLeft/hideRight state +
// scrollToLeft/Right) SÖKÜLDÜ (2026-06-09) — bizim layout asla horizontal-wrapper
// değil; oklar `display:none !important` ile gizleniyordu (ölü Cuba artıfaktı).
const SidebarMenu = ({
  setMainMenu,
  props,
  sidebartoogle,
  setNavActive,
  activeClass,
}) => {
  return (
    <nav className="sidebar-main" id="sidebar-main">
      <div id="sidebar-menu">
        <ul className="sidebar-links custom-scrollbar">
          <SidebarMenuItems
            setMainMenu={setMainMenu}
            props={props}
            sidebartoogle={sidebartoogle}
            setNavActive={setNavActive}
            activeClass={activeClass}
          />
        </ul>
      </div>
    </nav>
  );
};

export default SidebarMenu;
